import React, { Component, useEffect, useState, useMemo } from 'react';
import '../styles/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { GetSharedFromMeAll } from '../../actions/getSharedFromMeAll';
import DataTable, { createTheme } from "react-data-table-component";
import FilterComponent from './filterComponent';
import AccountMenu from './accountMenu';
import HamburgerMenu from './toolbar';
import ListButtons from './ListBar';
import NavigationNames from "./navigationNames";
export default function Uploadeds() {
    const dispatch = useDispatch();
    const { testvalue } = useParams();
    var userData = JSON.parse(localStorage.getItem('user'));
    const getSharedFromMeAllReducer = useSelector(state => state.GetSharedFromMeAllReducer);
    const [data, setData] = useState([]);
    const [dataFlag, setDataFlag] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    useEffect(() => {
        dispatch(GetSharedFromMeAll());
    },[])

    useEffect(() => {
        if (getSharedFromMeAllReducer && getSharedFromMeAllReducer.data && getSharedFromMeAllReducer.data.isSuccessful === true) {
            setData(getSharedFromMeAllReducer.data.data);
            setDataFlag(true);
        }
    }, [getSharedFromMeAllReducer]);

    const Header1 = ({ n }) => <span><b>{n}</b></span>
    ;
    const columns = [
        {
            name: <Header1 n={'Name'} />,
            selector: (row) => row.document['name'],
            cell: row => <div className="d-flex"><div style={{ alignItems: 'center', display: 'flex' }}></div><div>{row.document['name']}<br /> {row.document['description']}</div></div>,
            sortable: true,
            minWidth: "300px",

        },
        {
            name: <Header1 n={'Description'} />,
            selector: (row) => row.document['description'],
            cell: row => <div className="d-flex"><div style={{ alignItems: 'center', display: 'flex' }}></div><div>{row.document['description']}</div></div>,
            sortable: true,
            minWidth: "300px",

        },
        {
            name: "Reader",
            selector: (row) => row.readedBy,
            sortable: true,
            minWidth: "250px",
        }, {
            name: "Shared At",
            selector: (row) => row.createdAtRes.split('.')[0].replace('T', ' '),
            sortable: true,
            minWidth: "200px",
        },
        {
            name: "Expire At",
            selector: (row) => row.expireDate.split('.')[0].replace('T', ' ').replace('Z',' '),
            sortable: true,
            minWidth: "200px",
        },
        {
            name: "View",
            selector: (row) => (
                <div className="btn-group-actions">
                    <Link className="text-success btn btn-sm btn-success text-white" to={{
                        pathname: `/index/LinkEntry/${row.viewKey}`,
                    }} state={{ viewkey: row.viewKey, id: row.document.id, type: "LinkEntry" }} title="viewKey">
                        <i style={{ color: 'white' }} className="fa-regular fa-eye"></i>
                    </Link>
                </div>
            ),
            minWidth: "50px",
        },

    ];

    const filteredItems = data.filter(
        item =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <>
                <hr />
                <div style={{
                    position: 'relative',
                    display: 'flex',
                    width: '100%'
                }}>
                    <ListButtons show={false} />
                    <div className="zrtykLm">
                        <FilterComponent
                            onFilter={e => setFilterText(e.target.value)}
                            onClear={handleClear}
                            filterText={filterText}
                        />
                        <HamburgerMenu data={filteredItems} type={"uploads"} />
                    </div>
                </div>
            </>
        );
    }, [filterText, resetPaginationToggle, data]);

    const customPagination = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "All",
    }
    const tableCustomStyles = {

        headRow: {
            style: {
                color: '#223336',
                /*backgroundColor: '#e7eef0'*/
            },
        },
    }
    return (
        <div style={{ display: 'flex' }}>
            <div className="section mainDivRsT" style={{ width: '100%', minHeight: '100vh' }}>
                <ToastContainer />
                <AccountMenu activeChildMenu="Uploads" />
                <div className="me-3 mb-3 w-100 app-wrapper">
                    <div className="pb-8 pb-md-11 mt-md-n6">
                        <div className='currentMenuItem container-md'>
                            <NavigationNames MenuName="Shared PDF's" />
                        </div>
                        <div className="container-md">
                            {dataFlag &&
                                <div className="TableShared">
                                    <DataTable
                                        columns={columns}
                                        customStyles={tableCustomStyles}
                                        data={filteredItems}
                                        pagination
                                        paginationComponentOptions={customPagination}
                                        highlightOnHover
                                        striped
                                        defaultSortFieldId={1}
                                        defaultSortOrder="asc"
                                        subHeader
                                        subHeaderComponent={subHeaderComponent}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
